export const FEATURES = {
  GENERIC: ``,
  CUSTOM_EVENTS: `custom-events`,
  DATE_RANGE: `date-range`,
  EXPORT_CSV: `export-csv`,
  FILTER_LEVELS: `filter-levels`,
  BOOKMARK_MAXIMUM: `bookmark-maximum`,
} as const;
